// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__355De"};